// ------------------------------------
// Constants
// ------------------------------------

export const GET_SUBHEADER_NAME = 'GET_SUBHEADER_NAME'
export const SET_SUBHEADER_NAME = 'SET_SUBHEADER_NAME'
export const origin = window.location.hostname
// ------------------------------------
// Actions
// ------------------------------------

export const getSubheaderName = (data = null) => {
  return {
    type: GET_SUBHEADER_NAME,
    data: data
  }
}

export const setNameAction = (data = null) => {
  return {
    type: SET_SUBHEADER_NAME,
    data: data
  }
}

const getName = (name = null) => {
  let link
  if (name) {
    return (name)
  } else {
    link = window.location.pathname
  }
  return link
}

export const setMenuName = (name) => {
  return (dispatch) => {
    return new Promise((resolve) => {
      dispatch(setNameAction(name))
    })
  }
}

export const actions = {
  getSubheaderName,
  setMenuName
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [GET_SUBHEADER_NAME]: (state, action) => { return { ...state, name: getName(action ? action.data : null) } },
  [SET_SUBHEADER_NAME]: (state, action) => { return { ...state, name: action.data } }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  name: getName()
}
export default function menuleftReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/layouts/Layout/MainMenu/module/mainmenu.js